import ClipboardJS from "clipboard";
import Modal from "bootstrap.native/dist/components/modal-native.esm";

let clipboard = new ClipboardJS('.il-copy-url');

clipboard.on('success', function (e) {
    console.info('Action:', e.action);
    console.info('Text:', e.text);
    console.info('Trigger:', e.trigger);

    e.clearSelection();
});

/**
 * Set up modal for success message.
 */

let urlBtns = document.querySelectorAll('.il-copy-url');
urlBtns.forEach(btn => {
    let successModal = new Modal(btn);
    let modalContainer = document.querySelector(btn.dataset.target);
    modalContainer.addEventListener("shown.bs.modal", e => {
        setTimeout(() => successModal.hide(), 500);
    });
})

/**
 * Share image link button — copies /{slug}?img={mediaId} to clipboard
 */
document.addEventListener('click', function (e) {
    let btn = e.target.closest('.il-share-image-btn');
    if (!btn) return;

    e.stopPropagation();
    e.preventDefault();

    let mediaId = btn.dataset.mediaId;
    let slug = btn.dataset.locationSlug;
    // Per-button marker wins over the page-level global: a category grid
    // mixes event and non-event locations, so one page-wide flag cannot be
    // right for every tile. Absent both, the non-event path.
    let isEvent = btn.dataset.event === '1'
        || (typeof isEventLocation !== 'undefined' && isEventLocation);
    let path = isEvent ? '/events/' + slug : '/' + slug;
    let url = window.location.origin + path + '?img=' + mediaId;

    navigator.clipboard.writeText(url).then(function () {
        let modalEl = document.querySelector('#url-copied');
        if (modalEl) {
            let modal = new Modal(modalEl);
            modal.show();
            setTimeout(function () { modal.hide(); }, 500);
        }
    });
});


